/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.27.49
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ClaimReservationCommunicationMethod } from './ClaimReservationCommunicationMethod';
import {
    ClaimReservationCommunicationMethodFromJSON,
    ClaimReservationCommunicationMethodFromJSONTyped,
    ClaimReservationCommunicationMethodToJSON,
} from './ClaimReservationCommunicationMethod';

/**
 * 
 * @export
 * @interface AdminClaimReservationRequest
 */
export interface AdminClaimReservationRequest {
    /**
     * Timestamp of when the reservation was marked as a no-show by an admin
     * @type {Date}
     * @memberof AdminClaimReservationRequest
     */
    noShowAt?: Date | null;
    /**
     * Timestamp of when the reservation was marked as checked in by an admin
     * @type {Date}
     * @memberof AdminClaimReservationRequest
     */
    checkedInAt?: Date | null;
    /**
     * Optional field to capture if the reservation was most recently edited by a claims agent, and who that agent was
     * @type {string}
     * @memberof AdminClaimReservationRequest
     */
    editedByAgentName?: string | null;
    /**
     * Optional field to capture if the reservation was created internally by a claims agent on behalf of a player, and who that agent was
     * @type {string}
     * @memberof AdminClaimReservationRequest
     */
    createdByAgentName?: string | null;
    /**
     * Optional free form notes text about a reservation
     * @type {string}
     * @memberof AdminClaimReservationRequest
     */
    notes: string | null;
    /**
     * 
     * @type {number}
     * @memberof AdminClaimReservationRequest
     */
    numberOfTickets: number;
    /**
     * 
     * @type {ClaimReservationCommunicationMethod}
     * @memberof AdminClaimReservationRequest
     */
    communicationPreference: ClaimReservationCommunicationMethod;
    /**
     * Phone for the reservation, e.g. "123-456-7890"
     * Nullable for reservations made directly in the back office
     * @type {string}
     * @memberof AdminClaimReservationRequest
     */
    phone?: string | null;
    /**
     * Email for the reservation, e.g. "john.doe@example.com"
     * Nullable for reservations made directly in the back office
     * @type {string}
     * @memberof AdminClaimReservationRequest
     */
    email?: string | null;
    /**
     * Name for the reservation, e.g. "John Doe"
     * @type {string}
     * @memberof AdminClaimReservationRequest
     */
    name: string;
    /**
     * Encoded timeslot for reservation.
     * This value comes from the timeslot availability call of the player data service and internally encodes the
     * reservation location, date, time, and duration info.
     * @type {string}
     * @memberof AdminClaimReservationRequest
     */
    timeslotId: string;
}



/**
 * Check if a given object implements the AdminClaimReservationRequest interface.
 */
export function instanceOfAdminClaimReservationRequest(value: object): value is AdminClaimReservationRequest {
    if (!('notes' in value) || value['notes'] === undefined) return false;
    if (!('numberOfTickets' in value) || value['numberOfTickets'] === undefined) return false;
    if (!('communicationPreference' in value) || value['communicationPreference'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('timeslotId' in value) || value['timeslotId'] === undefined) return false;
    return true;
}

export function AdminClaimReservationRequestFromJSON(json: any): AdminClaimReservationRequest {
    return AdminClaimReservationRequestFromJSONTyped(json, false);
}

export function AdminClaimReservationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminClaimReservationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'noShowAt': json['noShowAt'] == null ? undefined : (new Date(json['noShowAt'])),
        'checkedInAt': json['checkedInAt'] == null ? undefined : (new Date(json['checkedInAt'])),
        'editedByAgentName': json['editedByAgentName'] == null ? undefined : json['editedByAgentName'],
        'createdByAgentName': json['createdByAgentName'] == null ? undefined : json['createdByAgentName'],
        'notes': json['notes'],
        'numberOfTickets': json['numberOfTickets'],
        'communicationPreference': ClaimReservationCommunicationMethodFromJSON(json['communicationPreference']),
        'phone': json['phone'] == null ? undefined : json['phone'],
        'email': json['email'] == null ? undefined : json['email'],
        'name': json['name'],
        'timeslotId': json['timeslotId'],
    };
}

export function AdminClaimReservationRequestToJSON(value?: AdminClaimReservationRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'noShowAt': value['noShowAt'] == null ? undefined : ((value['noShowAt'] as any).toISOString()),
        'checkedInAt': value['checkedInAt'] == null ? undefined : ((value['checkedInAt'] as any).toISOString()),
        'editedByAgentName': value['editedByAgentName'],
        'createdByAgentName': value['createdByAgentName'],
        'notes': value['notes'],
        'numberOfTickets': value['numberOfTickets'],
        'communicationPreference': ClaimReservationCommunicationMethodToJSON(value['communicationPreference']),
        'phone': value['phone'],
        'email': value['email'],
        'name': value['name'],
        'timeslotId': value['timeslotId'],
    };
}

